class Transaction {
    constructor(transaction) {
        this.transaction_overview = transaction.transaction_overview; // public property
        this.buyer_currency_id = transaction.buyer_currency_id ?? null;
        this.seller_currency_id = transaction.seller_currency_id ?? null;
        this.buyer_exchange_rate = transaction.buyer_exchange_rate ?? null;
        this.seller_exchange_rate = transaction.seller_exchange_rate ?? null;
        this.price_buyer_local = transaction.price_buyer_local ?? null;
        this.price_seller_local = transaction.price_seller_local ?? null;
    }
}

export default Transaction;
